// extracted by mini-css-extract-plugin
export default {"infoBox":"BlueBoxBanner_infoBox__BHd4i"};